'use client'
import { format } from 'date-fns'
import { X } from 'lucide-react'
import TimePicker from 'react-time-picker'
import 'react-time-picker/dist/TimePicker.css'

interface IProps {
  isClearable?: boolean
  onChange: (time: string) => void
  value: null | string | undefined
}

export const TimeInput = ({ isClearable = false, onChange, value }: IProps) => {
  const setTime = (time: string) => {
    if (time) {
      try {
        const parsedTime = format(time, 'H:mm')
        onChange(parsedTime)
      } catch {
        onChange(time)
      }
    }
  }

  const onClear = () => {
    onChange('')
  }

  return (
    <TimePicker
      className="[&>div]:rounded-md [&>div]:border-gray-300 [&>div]:p-1"
      clearIcon={<X className={'p-1 transition-colors duration-150 hover:text-brand'} />}
      disableClock={true}
      format="HH:mm"
      onChange={value => (value ? setTime(value) : onClear())}
      value={value}
    />
  )
}
